import StackedColumn from '../../../../../../utility/generateHighChart/columnChart/StackedColumn.abstract';

class DiversityEnrollmentFunnel extends StackedColumn {
  isStacked = false;
}

export default DiversityEnrollmentFunnel;
